import React from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { Button, Notification, TypographyBody } from '@honeycomb/ui-core';
export function FlightSearchNoResults({ hasFiltered, onResetFilters }) {
    const { resourceStrings: { NORESULTS_MATCHING_FILTERS_MAIN, NORESULTS_MATCHING_FILTERS_FLIGHTS_SUB, RESETFILTERSBUTTON_CAPTION, NO_SEARCH_RESULTS_FLIGHTS, NO_SEARCH_RESULTS_FLIGHTS_SUB, }, } = useGlobalContext();
    return (React.createElement("div", null,
        React.createElement(Notification, { color: "info", mb: 5 },
            React.createElement(TypographyBody, { weight: "bold", "data-id": "no-results-text" }, hasFiltered ? NORESULTS_MATCHING_FILTERS_MAIN : NO_SEARCH_RESULTS_FLIGHTS),
            React.createElement("p", { "data-id": "no-results-sub-text" }, hasFiltered ? NORESULTS_MATCHING_FILTERS_FLIGHTS_SUB : NO_SEARCH_RESULTS_FLIGHTS_SUB)),
        hasFiltered && (React.createElement(Button, { size: "l", color: "primary", fullWidth: { xs: true, m: false }, variant: "outlined", onClick: () => {
                if (onResetFilters) {
                    onResetFilters();
                }
            }, "data-id": "reset-filters" }, RESETFILTERSBUTTON_CAPTION))));
}
